import React from "react";

import { Text, View } from "@/styles/reactnative";

const TradersFollowersItems = ({ item, CoinType }: any) => {
  return (
    <View
      style={{
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "row",
      }}
    >
      <Text size={12}>{item}</Text>
      {CoinType ? <CoinType /> : null}
    </View>
  );
};

export default React.memo(TradersFollowersItems);
